export enum CancellationDocumentType {
  CANCELLATION_LETTER = 'CANCELLATION_LETTER',
  SIGNED_CANCELLATION_LETTER = 'SIGNED_CANCELLATION_LETTER',
  /** The contract being cancelled, as the customer uploaded it with their request. */
  POLICY_DOCUMENT = 'POLICY_DOCUMENT',
}

export const getCancellationDocumentTypeLabel = (
  type: CancellationDocumentType
): string => {
  switch (type) {
    case CancellationDocumentType.CANCELLATION_LETTER:
      return $localize`Lettre de résiliation`;
    case CancellationDocumentType.SIGNED_CANCELLATION_LETTER:
      return $localize`Lettre de résiliation signée`;
    case CancellationDocumentType.POLICY_DOCUMENT:
      return $localize`Contrat à résilier`;
    default:
      return type;
  }
};

/** Every role the back office may file under, in the enum's own order. */
export const SELECTABLE_CANCELLATION_DOCUMENT_TYPES = Object.values(
  CancellationDocumentType
);

/** Everything but the contract being cancelled: a letter is dated and the other is not. */
export const isCancellationLetterType = (
  type: CancellationDocumentType | ''
): boolean => !!type && type !== CancellationDocumentType.POLICY_DOCUMENT;
